import { Typography, TypographyProps } from '@mui/material'
import { FC } from 'react'

interface TruncatedTypographyProps extends TypographyProps {
    children: React.ReactNode
    maxWidth: number | string
    maxLines?: number
}

const TruncatedTypography: FC<TruncatedTypographyProps> = ({ children, maxWidth, maxLines = 1, ...props }) => {
    return (
        <Typography
            sx={{
                maxWidth,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'block'
            }}
            {...props}
        >
            {children}
        </Typography>
    )
}

export default TruncatedTypography
